'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var StatusDot = function StatusDot(_ref) {
  var children = _ref.children,
      status = _ref.status;
  return _react2.default.createElement(
    'div',
    { className: cx('xsui-status-dot', 'xsui-status-dot--' + status) },
    _react2.default.createElement('div', { className: cx('xsui-status-dot__icon') }),
    _react2.default.createElement(
      'div',
      { className: cx('xsui-status-dot__entry') },
      children
    )
  );
};

StatusDot.propTypes = {
  children: function children() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
  },
  status: _propTypes2.default.oneOf(['deactivated', 'disabled', 'testing', 'enabled', 'enabled-outline', 'error', 'refunded', 'refunded-outline', 'processing', 'processing-outline', 'active']).isRequired
};
exports.default = StatusDot;